const usePushNotifications = () => {
  const pushNotification = (message: string) => {
    if (Notification.permission === "granted")
      new Notification(message, {
        silent: true,
        body: "Check it!",
      });
  };

  return { pushNotification };
};

export default usePushNotifications;
